import { render, staticRenderFns } from "./sendBar.vue?vue&type=template&id=2223e638&scoped=true&"
import script from "./sendBar.vue?vue&type=script&lang=js&"
export * from "./sendBar.vue?vue&type=script&lang=js&"
import style0 from "./sendBar.vue?vue&type=style&index=0&id=2223e638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223e638",
  null
  
)

component.options.__file = "sendBar.vue"
export default component.exports